export default __webpack_public_path__ + "static/media/AidkonektLogoLarge.7f4c110d.png";